import { DefaultLocalImageName } from '@bingads-webui-campaign-react/static-local-image-selector';

export const proxyReadCoverComponentConfig = (componentConfig) => {
  const {
    imageId,
    imageName,
    imageWidth,
    imageHeight,
    cropSettings,
    fileName,
    editWithCropper,
    externalSrc,
  } = componentConfig;

  return {
    imageId,
    imageName: imageName || (imageId ? null : DefaultLocalImageName),
    imageWidth,
    imageHeight,
    cropSettings,
    fileName,
    editWithCropper,
    externalSrc,
  };
};
